import React from 'react';
import { Card } from '../../../../../components/Card/Card';
import { Effect } from '../../../../../components/Effect/Effect';
import { SalesDonut } from '../../../../../components/SalesDonut/SalesDonut';
import { t } from '../../../../../locales/translate';
import { withSuspendedCard } from '../../../../../util/suspense';
import { graphql } from '../../../../../generated';
import { useSuspenseQuery } from '../../../../../util/use_suspense_query';

const GET_EVENT_SALES_STATS = graphql(`
  query GetEventSalesStats($id: ID!) {
    event(id: $id) {
      id
      salesStats {
        processing
        available
        blocked
        cart
        local
        personalized
        reserved
        returned
        systemFree
        systemSold
        soldHard
        soldOnline
        sold
        used
        unused
      }
    }
  }
`);

interface Props {
  id: string;
}

function Overview$({ id }: Props): JSX.Element {
  const { data } = useSuspenseQuery(GET_EVENT_SALES_STATS, {
    variables: { id },
  });

  return (
    <Card title={t.general.overview}>
      <Effect>{<SalesDonut data={data.event.salesStats} legendType="aside" size="full" />}</Effect>
    </Card>
  );
}

export const Overview = withSuspendedCard(Overview$, {
  loadingTitle: t.general.overview,
  loadingHeight: 288,
});
